export const EVENTS_TYPES = {
  PRELOAD_FAVORITE_DATA: 'PRELOAD_FAVORITE_DATA',
  BALANCE_UPDATED: 'BALANCE_UPDATED',
  OPERATOR_CHANGED: 'OPERATOR_CHANGED',
};
